import 'simplebar/dist/simplebar';
import ScrollReveal from 'scrollreveal/dist/scrollreveal';
import fullpage from 'fullpage.js';

document.addEventListener('DOMContentLoaded', function () {
    if (document.documentElement.clientWidth <= 1024) {
        const sr = ScrollReveal();
        const slideBase = { distance: '120%' };
        sr.reveal('.slide-up', { ...slideBase, origin: 'bottom' });
        sr.reveal('.slide-right', { ...slideBase, origin: 'right' });
        sr.reveal('.slide-left', { ...slideBase, origin: 'left' });
        sr.reveal('.slide-down', { ...slideBase, origin: 'top' });
    }
});

document.addEventListener('DOMContentLoaded', function () {
    if (document.getElementById('fullpage')) {
        new fullpage('#fullpage', {
            licenseKey: '30E3BA0E-5AA74D9B-B24D8675-1E281F90',
            verticalCentered: false,
            menu: '.menu',
            scrollingSpeed: 1000,
            anchors: ['anchor-1', 'anchor-2', 'anchor-3', 'anchor-4', 'anchor-5'],
            paddingTop: '',
            navigation: true,
            responsiveWidth: 1025,
            navigationPosition: 'left',
            navigationTooltips: ['О нас', 'Мы делаем', 'Вопросы - ответы', 'Отзывы', 'Контакты'],
            normalScrollElements: '.screen__wrap, #contacts-modal, .modal',
        });
    }
});
